import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UserApiService} from '../../../../projects/api/src/user/user-api.service';
import {LocalStorageService} from '../../../../projects/api/src/locale-storage/locale-storage.service';

export interface Theme {
  cssClass: string;
  name: string;
  id: number;
  icon: string;
  colorScheme;
}

export enum ThemeEnum {
  'LightTheme',
  'DarkTheme',
}


@Injectable()
export class ThemeService {
  constructor(private userApi: UserApiService, private localStorageApi: LocalStorageService) {
    this.initService();
  }

  public current: Theme;

  private _themes: Theme[] = [
    {icon: 'u-text-black', cssClass: 'theme-dark', name: 'DarkTheme', colorScheme: 'dark', id: ThemeEnum.DarkTheme},
    {icon: 'u-text-white', cssClass: 'theme-light', name: 'LightTheme', colorScheme: 'light', id: ThemeEnum.LightTheme},
  ];

  get themes(): Theme[] {
    return this._themes;
  }

  public theme = new BehaviorSubject<Theme>(this._themes[0]);

  public setTheme(theme: Theme) {
    this.localStorageApi.save(true, 'theme', theme.id + '');
    this.current = theme;
    // this.theme.next(this._themes.find(_theme => _theme.id === theme));
    this.userApi.setProfileTheme(theme.id).subscribe(() => {
      this.theme.next(theme);
    });
  }


  private initService() {
    this.theme.subscribe(theme => {

        this.current = theme;
        this._themes.forEach(_theme => document.body.classList.remove(_theme.cssClass));
        document.body.classList.add(theme.cssClass);
      }
    );
  }
}
